<template>
  <div v-if="tenancyLoaded" class="tenancy">
    <transition name="fade">
      <router-view :defaultHeader="defaultHeader"></router-view>
    </transition>
  </div>
</template>

<script>
import i18nCommon from '@modules/i18n/mixins/Common';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'Tenancy',
  data() {
    return {
      tenancyLoaded: false,
    };
  },
  props: {
    rentalObjectId: [Number, String],
    landlordId: [Number, String],
    tenancyId: [String, Number],
    defaultHeader: String,
  },
  mixins: [i18nCommon],
  computed: {
    ...mapGetters(['isMobileView']),
    ...mapGetters('tenancy', ['getTenancy']),

    landlordIdAndTenancyId() {
      return `${this.landlordId}|${this.tenancyId}`;
    },
    translationErrorCouldNotFetchTenacyDetails() {
      return this.translate('error.could not fetch tenancy details');
    },
  },
  methods: {
    ...mapMutations('tenancy', ['clearCurrentTenancy']),
    ...mapActions('tenancy', ['fetchTenancy']),
  },
  watch: {
    landlordIdAndTenancyId: {
      async handler(newVal) {
        const [landlordId, tenancyId] = newVal.split('|');
        this.tenancyLoaded = false;
        try {
          await this.clearCurrentTenancy();
          await this.fetchTenancy({ landlordId, tenancyId });
          this.tenancyLoaded = true;
        } catch (error) {
          // eslint-disable-next-line
          console.error(error);
          this.$toast(this.translationErrorCouldNotFetchTenacyDetails, 'error');
        }
      },
      immediate: true,
    },
  },
};
</script>

<style scoped lang="scss">
.wrapper-area {
  width: calc(100% - 300px);
}

.fade-enter-active {
  animation: bounceIn 0.8s;
}

@keyframes bounceIn {
  0% {
    transform: translate3d(0, 40px, 0);
  }

  100% {
    transform: translate3d(0, 0, 0);
  }
}

.tenancy-content {
  position: relative;
  //padding: 16rem 4rem 4rem 4rem;
  //padding: 4rem;
  //position: relative;
  padding: 0 3rem 3rem 3rem;

  .blockContainer {
    box-shadow: $box-shadow-3;
  }
}

.tenancy-content-actions {
  margin-top: 16rem;
}

.tenancy-content-no-actions {
  margin-top: 10rem;
}
</style>
